function freezeTree(value) {
  if (value && typeof value === 'object' && !Object.isFrozen(value)) {
    Object.freeze(value);
    Object.values(value).forEach(freezeTree);
  }
  return value;
}

// A read capability must not leak the mutable catalogue or its load result.
export function createArticleReadPort(catalog, isDisposed = () => false) {
  return Object.freeze({
    get(key) { return isDisposed() ? null : freezeTree(structuredClone(catalog.get(key))); },
    async ensureArticles(keys) {
      if (isDisposed()) return;
      await catalog.ensureArticles([...keys]);
    },
    getArticleDescription1: catalog.getArticleDescription1,
    getArticleDescription2: catalog.getArticleDescription2,
    getArticleUnit: catalog.getArticleUnit
  });
}
